export enum GameTypeEnum {
  GoldRush = 1,
  ProgressiveFiftyFifty = 2
}
